export default __webpack_public_path__ + "static/media/banner2.988d4b8e.png";